import pool17 from "../abis/development/pools/17";
import pool12 from "../abis/development/pools/12";
import pool8 from "../abis/development/pools/8";

const host = "https://testnet.bscscan.com/address";

export default [
  {
    title: "17°C Cold Pool",
    contractAddress: "0x22d63358eaa03bc562b2009b07beaba093c92e8f",
    minApr: 159,
    abi: pool17.abi,
    url: `${host}/0x22d63358eaa03bc562b2009b07beaba093c92e8f`,
  },
  {
    title: "12°C Cold Pool",
    contractAddress: "0x6f00028fb02c9ecf0b76d6ae0329a1f41f0ead9e",
    minApr: 175,
    abi: pool12.abi,
    url: `${host}/0x6f00028fb02c9ecf0b76d6ae0329a1f41f0ead9e`,
  },
  {
    title: "8°C Cold Pool",
    contractAddress: "0xfbc94386f04bf5af217ffb4bd8bd0af53a106de6",
    abi: pool8.abi,
    minApr: 200,
    url: `${host}/0xfbc94386f04bf5af217ffb4bd8bd0af53a106de6`,
  },
];
